import { render, staticRenderFns } from "./ComentariosDialogComponent.vue?vue&type=template&id=30906ad7"
import script from "./ComentariosDialogComponent.vue?vue&type=script&lang=js"
export * from "./ComentariosDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports